import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

export default function MainHeader() {

    const [fontSize, setFontSize] = useState(16);

    useEffect(() => {
        document.documentElement.style.setProperty('--font-size-base', `${fontSize}px`);
    }, [fontSize]);

    const increaseFontSize = () => {
        setFontSize(prevSize => Math.min(prevSize + 2, 20));
    };

    const decreaseFontSize = () => {
        setFontSize(prevSize => Math.max(prevSize - 2, 14));
    };

    const resetFontSize = () => {
        setFontSize(16);
    };



    const [query, setQuery] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const lastNavigatedQuery = useRef('');

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            const trimmed = query.trim();

            if (trimmed && location.pathname !== `/search/${trimmed}`) {
                if (lastNavigatedQuery.current !== trimmed) {
                    lastNavigatedQuery.current = trimmed;
                    navigate(`/search/${trimmed}`);
                }
            } else if (!trimmed && location.pathname !== '/') {
                if (lastNavigatedQuery.current !== '') {
                    lastNavigatedQuery.current = '';
                    navigate('/');
                }
            }
        }, 800); // debounce delay

        return () => clearTimeout(delayDebounce);
    }, [query, navigate, location.pathname]);


    const [theme, setTheme] = useState(sessionStorage.getItem('theme') || 'light');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        sessionStorage.setItem('theme', theme); // Save theme to localStorage
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };



    return (
        <>
            <div className="newHeader--main">
                <div className="container space-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <div className="logo">
                                    <NavLink to="/home" className="light">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/logo_light_mode.png`} alt="logo" />
                                    </NavLink>
                                    <NavLink to="/home" className="dark"><img src= {`${process.env.PUBLIC_URL}/assets/images/logo_dark_mode.png`} alt="logo" /></NavLink>
                                </div>
                                <div className="searchSec">
                                    <div className="d-flex">
                                        <input className="form-control me-2" onChange={(e) => setQuery(e.target.value)} type="search" value={query} placeholder="Search" aria-label="Search" />
                                        <button className="searchSecBtn" type="submit">
                                            <svg id="Component_57_5" data-name="Component 57 – 5" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                <rect id="Rectangle_28255" data-name="Rectangle 28255" width="20" height="20" fill="rgba(255,255,255,0)" />
                                                <path id="Icon_ionic-ios-search" data-name="Icon ionic-ios-search" d="M19.8,18.855l-4.3-4.345a6.135,6.135,0,1,0-.931.943l4.277,4.317a.662.662,0,0,0,.935.024A.667.667,0,0,0,19.8,18.855Zm-9.125-3.35A4.844,4.844,0,1,1,14.1,14.087,4.814,4.814,0,0,1,10.671,15.505Z" transform="translate(-1.773 -1.766)" fill="#414141" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="rightSec">
                                    <div className="mobileApp d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#epustakalaya">
                                        <span>Download <br /> Mobile App</span>
                                        <img className='mobile-icon light' src={`${process.env.PUBLIC_URL}/assets/images/elements/smartphone.png`} alt='Mobile Icon' />
                                        <img className='mobile-icon dark' src={`${process.env.PUBLIC_URL}/assets/images/elements/smartphone_light.png`} alt='Mobile Icon' />
                                    </div>
                                    <span className="dividerSec">
                                        |
                                    </span>
                                    <div className="themeSec">

                                        <div onClick={toggleTheme} style={{ cursor: 'pointer' }}>
                                            <button className='btn f_increase view-all-btnn'>{theme === 'light' ? <i className="fas fa-sun"></i> : <i className="fas fa-moon"></i>}</button>
                                        </div>
                                    </div>

                                    <span className="dividerSec">
                                        |
                                    </span>

                                    <div className="textDropdwn">


                                        <button className='btn f_increase view-all-btnn' onClick={increaseFontSize}>A +</button>
                                        <button className='btn f_increase  view-all-btnn' onClick={resetFontSize}>A</button>
                                        <button className='btn f_increase  view-all-btnn' onClick={decreaseFontSize}>A -</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
